"use client";

import React from 'react';
import Image from './Image';
import Twitter from '@/assets/images/Twitter.svg'
import Telegram from '@/assets/images/Telegram.svg'

const Contact = () => {

    return (
        <div 
          className='w-full bg-cover bg-center flex justify-center items-center mt-24'
          data-aos="fade-up"
          data-aos-delay="500"
          data-aos-distance="1000px"
          data-aos-duration="300"
          data-aos-easing="ease-in-out"
        >
            <div className='main_container flex justify-center items-center '>
                <div className='flex bg-grad-custom backdrop-blur-[9.3px] border-[1px] border-button-border rounded-[20px] py-[53px] px-[42px] w-full max-w-[1200px]'>
                    <div className='w-1/2'>
                        <p className='gradient_bg_text bg-grad-title text-[60px] font-bold leading-[78px] tracking-[-1.6px] w-full'>
                            Contact Us
                        </p>
                        <p className='text-[17px] leading-[21px] text-textColor max-w-[268px]'>If you are looking for development support or just want to ask us a question, feel free to reach out!</p>
                        <div className='flex absolute bottom-20'>
                            <a href="#">
                                <Image src={Twitter} width={27} alt='Twitter'/>
                            </a>
                            <a href="#" className='ml-3'>
                                <Image src={Telegram} width={27} alt='Telegram'/>
                            </a>
                        </div>
                    </div>
                    <div className='w-1/2'>
                        <input type="text" className='border-[1px] border-button-border rounded-md h-[43px] bg-background gradient_bg_text bg-grad-title text-[20px] px-3 outline-none w-full text-white' name="text" />
                        <div className='mt-[18px]'>
                            <textarea name="textarea" className='border-[1px] p-2 border-button-border rounded-md bg-background gradient_bg_text bg-grad-title text-[20px] px-3 outline-none w-full min-h-[246px] text-white'></textarea>
                        </div>
                        <div className='px-8 py-2 border-[1px] border-button-border w-fit ml-auto mr-auto rounded-md text-[#517FB4] text-[14px] cursor-pointer bg-grad-button mt-10'>Submit</div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Contact;